<div class="guestInfo-container">
  <img src="assets/user.svg">
  <h1>{{'guest.info.title' | translate}}</h1>

  <form [formGroup]="fgroup">
    <div class="name-field" [hidden]="guestInfoSetting.setValue === '3' && !isCustNameRequired">
      <label>{{ 'input.label.19' | translate }}<span class="mandatory" *ngIf="isCustNameRequired">*</span></label>
      <input type="text" pInputText formControlName="name" placeholder="{{ 'input.placeholder.7' | translate }}" #name>

      <div class="invalid-feeback" *ngIf="!name.value && isCustNameRequired && requirField">
        <i class="oda-alert"></i>
        {{ 'qr.ref.no.required' | translate }}
      </div>
    </div>

    <div class="mobileNo-field" [hidden]="guestInfoSetting.setValue === '3' && !isMobilNoRequired">
      <label>{{ 'input.label.1' | translate }}<span class="mandatory" *ngIf="isMobilNoRequired">*</span></label>
      <ngx-intl-tel-input [cssClass]="" [enableAutoCountrySelect]="telInpSetting.enableAutoCountrySelect"
        [customPlaceholder]="telInpSetting.customPlaceholder | translate"
        [enablePlaceholder]="telInpSetting.enablePlaceholder" [searchCountryFlag]="telInpSetting.searchCountryFlag"
        [searchCountryField]="telInpSetting.searchCountryField" [selectFirstCountry]="telInpSetting.selectFirstCountry"
        [phoneValidation]="telInpSetting.phoneValidation" [inputId]="'phoneNo'"
        [separateDialCode]="telInpSetting.separateDialCode" [preferredCountries]="telInpSetting.preferredCountries"
        [selectedCountryISO]="telInpSetting.selectedCountryISO" name="phone" formControlName="mobileNo" #phone_number>
      </ngx-intl-tel-input>

      <div class="invalid-feeback" *ngIf="!phone_number.value && isMobilNoRequired && requirField">
        <i class="oda-alert"></i>
        {{ 'qr.ref.no.required' | translate }}
      </div>

      <div class="invalid-feeback" *ngIf="invalidMobileFormat">
        <i class="oda-alert"></i>
        {{ 'login.form.mobile.number.invalid' | translate }}
      </div>
    </div>

    <div class="email-field" [hidden]="guestInfoSetting.setValue === '3' && !isEmailRequired">
      <label>{{ 'input.label.8' | translate }}<span class="mandatory" *ngIf="isEmailRequired">*</span></label>
      <input type="text" pInputText formControlName="email" placeholder="{{ 'input.placeholder.8' | translate }}"
        #email>

      <div class="invalid-feeback" *ngIf="f.email.errors?.pattern">
        <i class="oda-alert"></i>
        {{ 'refund.return.email.error.email.invalid' | translate }}
      </div>

      <div class="invalid-feeback" *ngIf="!email.value && isEmailRequired && requirField">
        <i class="oda-alert"></i>
        {{ 'qr.ref.no.required' | translate }}
      </div>
    </div>

    <button class="continue-btn" (click)="onClickContinue()"
      [ngClass]="{'disabled-button': fg.invalid}">{{ isUpdate ?
      ('address.form.button.update' | translate ) : ('button.continue' | translate ) }}</button>
  </form>
</div>
